<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <DefaultTmpl>
        <template v-slot:main>
            <div class="container-403 t-c">
                Você não possui permissão de acesso a esse recurso.<br/><br/>
                <svg-icon svg-class="jump" icon="lock"/>
                <br/>
                <br/>
                <a href="javascript:history.go(-1)" class="btn btn-theme-1"><svg-icon icon="arrow-left"/> Voltar</a>
            </div>
        </template>
    </DefaultTmpl>
</template>

<script>
    import DefaultTmpl from "@/templates/DefaultTmpl";
    export default {
        name: "403",
        components:{DefaultTmpl}
    }
</script>

<style scoped lang="scss">
    .container-403 {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

         > svg {
            color: red;
        }
    }

    @keyframes jump {
        0%   {transform: translate3d(0,0,0)}
        100% {transform: translate3d(0,20%,0)}
    }
    .jump {
        transform-origin: 50% 50%;
        animation: jump 1s linear alternate infinite;
    }
</style>
